module.exports = __webpack_public_path__ + "static/img/target_a4.57345704.png";